export default {"src":"/_next/static/media/governance.9da63dbb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};